import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HxUserService, UserComponentModel } from 'hx-services';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-managers-info',
    templateUrl: './managers-info.component.html',
    styleUrls: ['./managers-info.component.css'],
    imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgFor, NgbDropdownItem, NgIf, TranslocoPipe]
})
export class HxManagersInfoComponent implements OnChanges {
  @Input() groupId?: number;
  list: UserComponentModel[] = [];
  show = false;

  constructor(
    private userService: HxUserService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['groupId'] && changes['groupId'].currentValue) {
      this.load();
    }
  }

  open() {
    this.show = !this.show;
  }

  private load() {
    this.userService.getManagers({ groupId: this.groupId }).subscribe(result => {
      this.list = result;
    });
  }
}
